export default {
    loading: {
        module: true
    },
    params: {
        type_format: 1,
        seller_id: [],
    },
    types_format: [{
        "id": 1,
        "name": "Estado de cuenta"
    },
    {
        "id": 2,
        "name": "Aviso Reporte Negativo"
    },
    {
        "id": 3,
        "name": "Aviso Cobro juridico"
    }],
    contacts_mails: [],
    contacs_selecteds: [],
    ag_grid: {
        selectedTheme: 'ag-theme-balham'
    },
    subscriber: {
        document: {}
    },
    sellers:[],
}



// WEBPACK FOOTER //
// ./src/modules/masive-mails/state.js